import { useTranslations } from '@lang';
import { useNavigationLabels } from './queries';
import { getLanguageCodeFromLocale } from '@utils/getLanguageCodeFromLocale';

export function useLabels() {
  const { locale } = useTranslations();
  const { data } = useNavigationLabels();
  const navigationLabels = data?.[getLanguageCodeFromLocale(locale)] || {};

  return navigationLabels;
}
